    import { Component, OnInit } from '@angular/core';
    import {ActivatedRoute, Router} from '@angular/router';
    @Component({
      selector: 'app-logintype',
      templateUrl: './logintype.component.html',
      styleUrls: ['./logintype.component.css']
    })
    export class LogintypeComponent implements OnInit {
      selectedLink: String ;
      constructor(private router: Router) { }

      ngOnInit() {
      }
        setradio(e: string) {
        this.selectedLink = e;
      }
      goToLoginPage() {
        if (this.selectedLink === 'Docs') {
          this.router.navigate(['/doctorlogin']);
        } else {
          this.router.navigate(['/signin']);
        }
      }
    }
